export type WizardMessage = string | Record<string, unknown>;

import { createLogger } from "./logger";

const logger = createLogger("wizardMessaging");

export function sendMessageToWizard(
    wizardWindow: Window | null,
    payload: unknown,
    targetOrigin: string
) {
    if (!wizardWindow || wizardWindow.closed) {
        logger.warning("Wizard pop up is not open.");
        return;
    }

    wizardWindow.postMessage(payload, targetOrigin);
}

export function isAllowedOrigin(origin: string, allowedOrigins: string[]) {
    return allowedOrigins.includes(origin);
}